import { FC, ReactNode, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { themeColor } from '../../../layout/theme/color'

interface DisclosureSectionProps {
  title: string
  defaultOpen?: boolean
  /** When this flips to true the section opens itself. */
  forceOpen?: boolean
  adornment?: ReactNode
  children: ReactNode
}

const DisclosureSection: FC<DisclosureSectionProps> = ({
  title,
  defaultOpen = false,
  forceOpen = false,
  adornment,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen || forceOpen)

  useEffect(() => {
    if (forceOpen) setOpen(true)
  }, [forceOpen])

  return (
    <Box>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          'display': 'flex',
          'alignItems': 'center',
          'gap': 0.75,
          'px': 0.75,
          'py': 0.5,
          'mx': -0.75,
          'cursor': 'pointer',
          'borderRadius': '8px',
          'userSelect': 'none',
          '&:hover': { background: themeColor.slate05 },
        }}
      >
        <Typography
          variant="overline"
          sx={{ fontSize: 10, fontWeight: 700, color: themeColor.slate40, letterSpacing: 1, lineHeight: 1.6 }}
        >
          {title}
        </Typography>
        {adornment}
        <Box sx={{ flex: 1 }} />
        <IconButton size="small" sx={{ p: 0 }}>
          {open ? (
            <ExpandLessIcon sx={{ fontSize: 16 }} />
          ) : (
            <ExpandMoreIcon sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Box>
      <Collapse in={open}>
        <Box sx={{ mt: 0.75 }}>{children}</Box>
      </Collapse>
    </Box>
  )
}

export default DisclosureSection
